import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { PriceListProduct, priceListProductType } from '../../types/slices/priceListProductType'

const initialState: priceListProductType =
{
    status: ApiStatus.FETCHED,
    priceListProduct: [],
    priceListSelectedProduct: {} as PriceListProduct,
    errorMessage: undefined,
    action: ''
}

const priceListProductSlice = createSlice({
    name: 'priceListProductSlice',
    initialState,
    reducers: {
        onFetchPriceListProduct (state, { payload }: { payload: PriceListProduct[]}) {
            state.status = ApiStatus.FETCHED
            state.priceListProduct = payload
            state.errorMessage = undefined
        },
        onSetSelectedPriceListProduct (state, { payload }: { payload: PriceListProduct }) {
            state.priceListSelectedProduct = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectPriceListProductState = (state: RootState) => state.priceListProductSlice
export default priceListProductSlice.reducer
export const {
    onFetchPriceListProduct,
    onSetSelectedPriceListProduct,
    changeStatus,
    setAction,
} = priceListProductSlice.actions
